import { observer } from "mobx-react"
import { TextField, Box, useTheme, Typography } from "@mui/material"
import { t } from "@lingui/macro"

import { EditProductStore } from "src/views/product-catalogue/edit/store"
import { useStore } from "src/store/lib/useStore"
import { Alert16 } from "src/components/icons/Alert16"
import { Icon } from "src/components/icons"
import { Tooltip } from "src/components/Tooltips/Tooltip"

export const Name = observer(() => {
    const store = useStore(EditProductStore)
    const theme = useTheme()

    return (
        <Box
            sx={{ display: "flex", gap: "8px" }}
            style={{ breakInside: "avoid" }}
        >
            <TextField
                label={t`edit-product-view.name.label`}
                type="search"
                value={store.formFields.get("name") ?? ""}
                onChange={store.formFields.setter("name")}
                error={Boolean(store.formFields.error("name"))}
                helperText={store.formFields.error("name")}
            />
            <Tooltip title={t`edit-product-view.name.tooltip`} arrow>
                <Typography sx={{ marginTop: "16px" }}>
                    <Icon
                        icon={<Alert16 width="20px" height="20px" />}
                        color={theme.palette.grey[700]}
                    />
                </Typography>
            </Tooltip>
        </Box>
    )
})
